module.exports = __webpack_public_path__ + "img/messageIcon.049b2e61.png";